!function (e) {
  var i = "(?:\\([^|)]+\\)|\\[[^\\]]+\\]|\\{[^}]+\\})+",
      n = {
    css: {
      pattern: /\{[^}]+\}/,
      inside: {
        rest: e.languages.css
      }
    },
    "class-id": {
      pattern: /(\()[^)]+(?=\))/,
      lookbehind: !0,
      alias: "attr-value"
    },
    lang: {
      pattern: /(\[)[^\]]+(?=\])/,
      lookbehind: !0,
      alias: "attr-value"
    },
    punctuation: /[\\\/]\d+|\S/
  };
  e.languages.textile = e.languages.extend("markup", {
    phrase: {
      pattern: /(^|\r|\n)\S[\s\S]*?(?=$|\r?\n\r?\n|\r\r)/,
      lookbehind: !0,
      inside: {
        "block-tag": {
          pattern: RegExp("^[a-z]\\w*(?:" + i + "|[<>=()])*\\."),
          inside: {
            modifier: {
              pattern: RegExp("(^[a-z]\\w*)(?:" + i + "|[<>=()])+(?=\\.)"),
              lookbehind: !0,
              inside: n
            },
            tag: /^[a-z]\w*/,
            punctuation: /\.$/
          }
        },
        list: {
          pattern: RegExp("^[*#]+(?:" + i + ")?\\s+.+", "m"),
          inside: {
            modifier: {
              pattern: RegExp("(^[*#]+)" + i),
              lookbehind: !0,
              inside: n
            },
            punctuation: /^[*#]+/
          }
        },
        table: {
          pattern: RegExp("^(?:(?:" + i + "|[<>=()^~])+\\.\\s*)?(?:\\|(?:(?:" + i + "|[<>=()^~_]|[\\\\/]\\d+)+\\.)?[^|]*)+\\|", "m"),
          inside: {
            modifier: {
              pattern: RegExp("(^|\\|(?:\\r?\\n|\\r)?)(?:" + i + "|[<>=()^~_]|[\\\\/]\\d+)+(?=\\.)"),
              lookbehind: !0,
              inside: n
            },
            punctuation: /\||^\./
          }
        },
        inline: {
          pattern: RegExp("(\\*\\*|__|\\?\\?|[*_%@+\\-^~])(?:" + i + ")?.+?\\1"),
          inside: {
            bold: {
              pattern: RegExp("(^(\\*\\*?)(?:" + i + ")?).+?(?=\\2)"),
              lookbehind: !0
            },
            italic: {
              pattern: RegExp("(^(__?)(?:" + i + ")?).+?(?=\\2)"),
              lookbehind: !0
            },
            cite: {
              pattern: RegExp("(^\\?\\?(?:" + i + ")?).+?(?=\\?\\?)"),
              lookbehind: !0,
              alias: "string"
            },
            code: {
              pattern: RegExp("(^@(?:" + i + ")?).+?(?=@)"),
              lookbehind: !0,
              alias: "keyword"
            },
            inserted: {
              pattern: RegExp("(^\\+(?:" + i + ")?).+?(?=\\+)"),
              lookbehind: !0
            },
            deleted: {
              pattern: RegExp("(^-(?:" + i + ")?).+?(?=-)"),
              lookbehind: !0
            },
            span: {
              pattern: RegExp("(^%(?:" + i + ")?).+?(?=%)"),
              lookbehind: !0
            },
            modifier: {
              pattern: RegExp("(^\\*\\*|__|\\?\\?|[*_%@+\\-^~])" + i),
              lookbehind: !0,
              inside: n
            },
            punctuation: /[*_%?@+\-^~]+/
          }
        },
        "link-ref": {
          pattern: /^\[[^\]]+\]\S+$/m,
          inside: {
            string: {
              pattern: /(\[)[^\]]+(?=\])/,
              lookbehind: !0
            },
            url: {
              pattern: /(\])\S+$/,
              lookbehind: !0
            },
            punctuation: /[\[\]]/
          }
        },
        link: {
          pattern: RegExp('"(?:' + i + ')?[^"]+":.+?(?=[^\\w/]?(?:\\s|$))'),
          inside: {
            text: {
              pattern: RegExp('(^"(?:' + i + ')?)[^"]+(?=")'),
              lookbehind: !0
            },
            modifier: {
              pattern: RegExp('(^")' + i),
              lookbehind: !0,
              inside: n
            },
            url: {
              pattern: /(:).+/,
              lookbehind: !0
            },
            punctuation: /[":]/
          }
        },
        image: {
          pattern: RegExp("!(?:" + i + "|[<>=()])*[^!\\s()]+(?:\\([^)]+\\))?!(?::.+?(?=[^\\w/]?(?:\\s|$)))?"),
          inside: {
            source: {
              pattern: RegExp("(^!(?:" + i + "|[<>=()])*)[^!\\s()]+(?:\\([^)]+\\))?(?=!)"),
              lookbehind: !0,
              alias: "url"
            },
            modifier: {
              pattern: RegExp("(^!)(?:" + i + "|[<>=()])+"),
              lookbehind: !0,
              inside: n
            },
            url: {
              pattern: /(:).+/,
              lookbehind: !0
            },
            punctuation: /[!:]/
          }
        },
        footnote: {
          pattern: /\b\[\d+\]/,
          alias: "comment",
          inside: {
            punctuation: /\[|\]/
          }
        },
        acronym: {
          pattern: /\b[A-Z\d]+\([^)]+\)/,
          inside: {
            comment: {
              pattern: /(\()[^)]+(?=\))/,
              lookbehind: !0
            },
            punctuation: /[()]/
          }
        },
        mark: {
          pattern: /\b\((?:TM|R|C)\)/,
          alias: "comment",
          inside: {
            punctuation: /[()]/
          }
        }
      }
    }
  });
  var t = {
    inline: e.languages.textile.phrase.inside.inline,
    link: e.languages.textile.phrase.inside.link,
    image: e.languages.textile.phrase.inside.image,
    footnote: e.languages.textile.phrase.inside.footnote,
    acronym: e.languages.textile.phrase.inside.acronym,
    mark: e.languages.textile.phrase.inside.mark
  };
  e.languages.textile.tag.pattern = /<\/?(?!\d)[a-z0-9]+(?:\s+[^\s>\/=]+(?:=(?:("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|[^\s'">=]+))?)*\s*\/?>/i, e.languages.textile.phrase.inside.inline.inside.bold.inside = t, e.languages.textile.phrase.inside.inline.inside.italic.inside = t, e.languages.textile.phrase.inside.inline.inside.inserted.inside = t, e.languages.textile.phrase.inside.inline.inside.deleted.inside = t, e.languages.textile.phrase.inside.inline.inside.span.inside = t, e.languages.textile.phrase.inside.table.inside.inline = t.inline, e.languages.textile.phrase.inside.table.inside.link = t.link, e.languages.textile.phrase.inside.table.inside.image = t.image, e.languages.textile.phrase.inside.table.inside.footnote = t.footnote, e.languages.textile.phrase.inside.table.inside.acronym = t.acronym, e.languages.textile.phrase.inside.table.inside.mark = t.mark;
}(Prism);